import React from "react";
import CorpDeungiSearchBox from "./CorpDeungiSearchBox";
import CorpDeungiListBox from "./CorpDeungiListBox";

type DeungiContentsPropsType = {
    handleSelect: string;
};

const CorpDeungiContents = ({ handleSelect }: DeungiContentsPropsType) => {
    return <>{handleSelect === "search" ? <CorpDeungiSearchBox /> : <CorpDeungiListBox />}</>;
};
export default CorpDeungiContents;
